interface ExtraFieldsToDisplay {
  [key: string]: Array<{
    key: string;
    label: string;
    separation?: string;
  }>;
}

export const CODE_TOKEN = "{##code##}";

export const extraFieldsToDisplay: ExtraFieldsToDisplay = {
  "TOYSC-IT": [{ key: "online_code", label: "Codice Utilizzo Online" }],
  "BSTORE-IT": [{ key: "online_code", label: "Codice Utilizzo Online" }],
  "GEMO-FR": [{ key: "online_code", label: "Code en ligne" }],
  "TARGT-US": [
    {
      key: "event_number",
      label: "Event Number",
      separation: "{1}-{3}-{2}-{4}-{1}",
    },
  ],
};

export const customRedeemURLs: { [key: string]: string } = {
  "AMZ-GB": "http://www.amazon.co.uk/gc/redeem?claimCode=" + CODE_TOKEN,
  "AMZ-DE": "http://www.amazon.de/gc/redeem?claimCode=" + CODE_TOKEN,
  "AMZ-ES": "http://www.amazon.es/gc/redeem?claimCode=" + CODE_TOKEN,
  "AMZ-FR": "http://www.amazon.fr/gc/redeem?claimCode=" + CODE_TOKEN,
  "AMZ-IT": "http://www.amazon.it/gc/redeem?claimCode=" + CODE_TOKEN,
  "AMZ-NL": "http://www.amazon.nl/gc/redeem?claimCode=" + CODE_TOKEN,
  "AMZ-US": "http://www.amazon.com/gc/redeem?claimCode=" + CODE_TOKEN,
  "PLAY-GB": "https://play.google.com/redeem?code=" + CODE_TOKEN,
};
